import { FleetConstantClassCollection } from "../models/FleetConstantClassCollection";

export class GetFleetConstantClassCollectionResponse {
    fleetConstantClassCollection?: FleetConstantClassCollection;
}